import type { MatchingSetRepository } from '../../domain/interfaces/MatchingSetRepository';

export type MatchingSetService = ReturnType<typeof createMatchingSetService>;

export function createMatchingSetService(repo: MatchingSetRepository) {
  return {
    getMatchingSet(designId: string) {
      return repo.fetchMatchingSet(designId);
    },
  };
}
